import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableColumnsType } from 'antd';
import Button from '../../../Button';
import { IStudentTestInfoOcean } from '../../../../models/students.model';
import useAxios from '../../../../hooks/useAxios';
import { IGetOceanUrl } from '../../../../models/oceanTest.model';
import { getOceanResultUrl, getPredigerHistoryCode } from '../../../../api/oceanTest.api';
import moment from 'moment';
import { getCommonCodeLabel } from '../../../../lib/store';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import Loader from '../../../Loader';
import ErrorResponse from '../../../ErrorResponse';
import { getWebUrl } from '../../../../lib/util';

interface IProps {
  data?: IStudentTestInfoOcean[];
  eduStepCode?: string;
}

const StudentOceanTable: FC<IProps> = ({
  data,
  eduStepCode
}) => {
  const { t, i18n } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetOceanUrl>();
  const { data: predigerResponse, isLoading: isPredigerLoading, error: predigerError, execute: predigerExecute } = useAxios<any>();

  useEffect(() => {
    if (res) {
      window.open(`${res?.data}&employeeMemberCode=${auth.memberCode}`, '_blank', 'width=1200, height=768, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');
    }
  }, [res]);

  useEffect(() => {
    if (predigerResponse && !isPredigerLoading) {
      const left = (window.screen.width - 1024) / 2;
      const top = (window.screen.height - 876) / 2;
      window.open(`${getWebUrl()}/prediger/${predigerResponse?.data}`, `prediger/${predigerResponse?.data}`, `width=1024, height=876, top=${top}, left=${left}, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no`);
    }
  }, [predigerResponse, isPredigerLoading])

  const onOpenOceanResultPopup = (oceanTestCode: number) => {
    if (eduStepCode === "MD") {
      predigerExecute(getPredigerHistoryCode(oceanTestCode));
      return;
    }
    execute(getOceanResultUrl(oceanTestCode));
  }

  const columns: TableColumnsType<IStudentTestInfoOcean> = [
    {
      title: t('common.label.1'),
      dataIndex: 'eduStepCode',
      key: 'eduStepCode',
      align: 'center',
      render: value => getCommonCodeLabel('PR0006', value, i18n.language),
    },
    {
      title: t('common.column.category'),
      dataIndex: 'examDiv',
      key: 'examDiv',
      align: 'center',
      render: value => getCommonCodeLabel('TE0001', value, 'ko')
    },
    {
      title: t('student.student.column115'),
      dataIndex: 'testSrtDate',
      key: 'testSrtDate',
      align: 'center',
      render: value => value ? moment(value).format('YYYY.MM.DD') : '-',
    },
    {
      title: t('student.student.column116'),
      dataIndex: 'testNo',
      key: 'testNo',
      align: 'center',
      render: value => {
        return (
          <div className="comm-btn__area justify-content-center">
            <Button
              className="btn-basic small mint"
              text={t('student.student.button23')}
              onClick={() => onOpenOceanResultPopup(value)}
            />
          </div>
        );
      },
    },
  ];

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={data?.filter(item => item.testCompleteYn === 'Y')}
      />
    </>
  );
};

export default StudentOceanTable;
